'use-client';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import * as React from 'react';
import type { PopoverTriggerElementProps } from 'wix-style-react';
import { PopoverMenu as WSRPopoverMenu } from 'wix-style-react';
import StylableButton from '../../StylableButton/viewer/StylableButton';

import type { IPopoverMenuProps } from '../PopoverMenu.props';
import { st, classes } from './PopoverMenu.component.st.css';

type PopoverMenuTriggerProps = Pick<
  IPopoverMenuProps,
  'id' | 'onClick' | 'icon' | 'popoverLabel'
> & { toggle: () => void };

const PopoverTrigger: React.FC<PopoverMenuTriggerProps> = props => {
  const { id, onClick, icon, popoverLabel, toggle } = props;

  return (
    <StylableButton
      onClick={(...args) => {
        toggle();
        if (onClick) {
          onClick(...args);
        }
      }}
      id={id}
      a11y={{}}
      link={undefined}
      // FYI: link is 'undefined' so 'renderDisabledLinkAsButton' can be always 'false'. Connect it to 'specs.thunderbolt.fixDisabledLinkButtonStyles' in case if link is present.
      renderDisabledLinkAsButton={false}
      type="button"
      svgString={icon.svgId}
      label={popoverLabel}
      isDisabled={false}
      className={classes.button}
    />
  );
};

const PopoverMenu: React.FC<IPopoverMenuProps> = props => {
  const { className, id, items, forceOpenPopover, stylableClassName } = props;

  const [triggerElementActions, setTriggerElementActions] =
    React.useState<PopoverTriggerElementProps | null>();

  React.useEffect(() => {
    if (!triggerElementActions) {
      return;
    }

    if (forceOpenPopover) {
      triggerElementActions.open();
    } else {
      // @ts-expect-error - missing event param for close function
      triggerElementActions.close();
    }
  }, [triggerElementActions, forceOpenPopover]);

  const renderTriggerElement = (params: PopoverTriggerElementProps) => {
    if (!triggerElementActions) {
      setTriggerElementActions(params);
    }
    return <PopoverTrigger {...props} toggle={params.toggle} />;
  };

  return (
    <div {...getDataAttributes(props)} id={id} className={className}>
      <WSRPopoverMenu
        appendTo="parent"
        className={st(classes.root, {}, stylableClassName)}
        triggerElement={renderTriggerElement}
      >
        {items.map(({ label }) => (
          <WSRPopoverMenu.MenuItem text={label} />
        ))}
      </WSRPopoverMenu>
    </div>
  );
};

export default PopoverMenu;
